import { useContext } from 'react';
import { Grid, Link, Typography } from '@mui/material';
import { shipmentContext } from '../ShipmentContext';
import Moment from 'react-moment';
import { DetailsPageHeader } from 'components';

let ShipmentDetails = () => {
    let service = useContext(shipmentContext);

    return (
        <DetailsPageHeader sectionName='Info'>
            <Grid container>
                <Grid item xs={3}>
                    <Typography>Id</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.shipment.shipmentId}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Date</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>
                        {!service.shipment.shipmentDate && '-'}
                        {service.shipment.shipmentDate &&
                            <Moment date={service.shipment.shipmentDate} format="LLL" />
                        }
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Carrier</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>{service.shipment.carrierCode}</Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography>Tracking number</Typography>
                </Grid>
                <Grid item xs={9}>
                    {service.shipment.trackingNumber &&
                        <Link href={service.shipment.trackingUrl} target="_blank">
                            {service.shipment.trackingNumber}
                        </Link>
                    }
                    {!service.shipment.trackingNumber && 'not available'}
                </Grid>
                {service.shipment.glsContractNumber &&
                    <>
                        <Grid item xs={3}>
                            <Typography>GLS Contract Number</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography>{service.shipment.glsContractNumber}</Typography>
                        </Grid>
                    </>
                }
                {service.shipment.glsBranchCode &&
                    <>
                        <Grid item xs={3}>
                            <Typography>GLS Branch Code</Typography>
                        </Grid>
                        <Grid item xs={9}>
                            <Typography>{service.shipment.glsBranchCode}</Typography>
                        </Grid>
                    </>
                }
                <Grid item xs={3}>
                    <Typography>Delivery status</Typography>
                </Grid>
                <Grid item xs={9}>
                    <Typography>
                        {service.shipment.deliveryStatus}
                        {service.shipment.deliveryStatus && service.shipment.glsStatus && ' - '}
                        {service.shipment.glsStatus}
                    </Typography>
                </Grid>
            </Grid>
        </DetailsPageHeader>
    );
}

export default ShipmentDetails;